import type { ReactNode } from "react";
import * as Sentry from "@sentry/react";
import type { FallbackRender } from "@sentry/react";

const Fallback: FallbackRender = ({ error }) => (
  <div
    role="alert"
    className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center"
  >
    <h1 className="text-2xl font-semibold">Something went wrong</h1>
    <p className="max-w-md text-sm text-gray-600">
      {error instanceof Error ? error.message : String(error)}
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
    >
      Reload
    </button>
  </div>
);

/** Captures render crashes to Sentry (no-op when uninitialized). */
export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={Fallback}>{children}</Sentry.ErrorBoundary>
  );
}
